export const exportJson = data => {
  const json = JSON.stringify(data, null, 2);
  const blob = new Blob([json], { type: "application/json" });

  const downloader = document.createElement("a");
  downloader.href = URL.createObjectURL(blob);
  downloader.download = `report_${new Date().getTime()}`;
  downloader.click();
};
